/**
 * BeraPaw LBGT — BeraPawForge redemption read surface.
 *
 * LBGT → BERA redemptions are tracked per-user by `redeemPosition(account)`
 * which returns `(queued, available)` LBGT amounts (1:1 with BERA). No
 * per-request id to enumerate — `queued` is the still-locked portion,
 * `available` is claimable now. `queueDelay()` is the cooldown.
 */
export const BeraPawForgeWithdrawalAbi = [
  {
    name: 'redeemPosition',
    type: 'function',
    stateMutability: 'view',
    inputs: [{ name: 'account', type: 'address' }],
    outputs: [
      { name: 'queued', type: 'uint128' },
      { name: 'available', type: 'uint128' },
    ],
  },
  {
    name: 'queueDelay',
    type: 'function',
    stateMutability: 'view',
    inputs: [],
    outputs: [{ type: 'uint96' }],
  },
] as const
